import React, { useContext, useEffect, useState } from "react";
import { Container, Card, Modal } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { AuthContext } from "../contexts/Auth.js";
import { db } from "../Firebase.js";
import {
  getDocs,
  collection,
  doc,
  getDoc,
  writeBatch,
} from "firebase/firestore";

import { DoubleBubble } from "react-spinner-animated";
import "react-spinner-animated/dist/index.css";
import downloadIcon from "../images/icons/icon-upload-primary.svg";
import axios from "axios";

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { TabView, TabPanel } from "primereact/tabview";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "../styles/count.css";
import "../styles/exceptions.css";

function InventoryExceptions() {
  const history = useHistory();
  const { userInfo } = useContext(AuthContext);

  const [showEntryDiv, setEntryDiv] = useState(true);
  const [showExceptionDiv, setShowExceptionDiv] = useState(false);
  const [countReady, setCountReady] = useState(true);
  const [showResults, setShowResults] = useState(false);

  const [inventoryReady, setInventoryReady] = useState(false);

  const [location, setLocation] = useState("");
  const [countReportVINs, setCountReportVINs] = useState([]);
  const [inventoryVINs, setInventoryVINs] = useState([]);

  const [unders, setUnders] = useState([]);
  const [overs, setOvers] = useState([]);

  const [inventoryData, setInventoryData] = useState([]); // State to store the inventory data

  const [loading, setLoading] = useState(true);
  const [loadingText, setLoadingText] = useState("");

  const [lots, setLots] = useState([]);

  const [activeIndex, setActiveIndex] = useState(0); // State to manage active tab index for Tables

  const [subHeader, setSubHeader] = useState(
    "Select an Autogroup" //"or pull from Inventory"
  );

  const countCols = [
    { field: "vin", header: "Vin" },
    { field: "make", header: "Make" },
    { field: "model", header: "Model" },
    { field: "year", header: "Year" },
    { field: "date", header: "Date" },
    { field: "locOrigin", header: "Location" },
    { field: "cost", header: "Cost" },
  ];

  const invCols = [
    { field: "vin", header: "VIN" },
    { field: "make", header: "Make" },
    { field: "model", header: "Model" },
    { field: "year", header: "Year" },
    { field: "cost", header: "Cost" },
  ];

  const oversCols = [
    { field: "vin", header: "Vin" },
    { field: "date", header: "Date" },
    { field: "locOrigin", header: "Location" },
  ];

  const oversColumns = oversCols.map((col) => {
    return (
      <Column key={col.field} field={col.field} header={col.header} sortable />
    );
  });

  const countColumns = countCols.map((col) => {
    return (
      <Column key={col.field} field={col.field} header={col.header} sortable />
    );
  });

  const inventoryColumns = invCols.map((col) => {
    return (
      <Column
        key={col.field}
        field={col.field}
        header={col.header}
        sortable
      ></Column>
    );
  });

  useEffect(() => {
    setLoading(true);
    setLoadingText("Loading...");

    if (userInfo !== undefined) {
      setLoading(true);
      setLoadingText("Loading Locations...");
      getLots();
    }

    if (countReady && location && location.length > 0) {
      setLoading(true);
      setLoadingText("Fetching Count Report...");
      hasCountReport();
    }

    if (inventoryReady && location && location.length > 0) {
      setLoading(true);
      setLoadingText("Fetching Inventory Report...");
      fetchInventoryToken(0);
    }
  }, [userInfo, location, countReady, inventoryReady]);

  async function getLots() {
    const lotItems = [];

    const docDateRef = doc(db, "orgs", userInfo.org);
    const docDateSnap = await getDoc(docDateRef);

    if (docDateSnap.exists()) {
      // setLastUpdated(docDateSnap.data().except_date_deleted);
      //   setLastUpdated(getLastCleared(docDateSnap.data().except_date_deleted));
    } else {
      console.log("No such document!");
    }

    const docRef = collection(db, "orgs", userInfo.org, "lots");
    const querySnapshot = await getDocs(docRef);

    querySnapshot.forEach((doc) => {
      lotItems.push(doc.data());
      // console.log("Lot Data:", doc.data());
    });

    setLoading(false);
    setLots(lotItems);
  }

  async function hasCountReport() {
    setCountReady(false);
    console.log("Checking for count report for location: " + location);
    const docRef = doc(db, "orgs", userInfo.org, "lots", location);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      if (docSnap.data().countCompleted) {
        if (docSnap.data().id) {
          getLocationReport(0);

          /***********************************
           * TODO --- TEKION API WITH DEALER ID
           * //Get inventory from Tekion
           * getLocationReport(docSnap.data().id);
           *
           *************************************/
        } else {
          // getLocationReport(0); //Loads Excel Input
        }
      } else {
        console.log("no count report found");
      }
    } else {
      console.log("no data exists");
    }
  }

  async function getLocationReport(tekionDealerId) {
    setLoading(true);
    setLoadingText("Fetching Count Report...");

    const countItems = [];
    const vinsRef = collection(
      db,
      "orgs",
      userInfo.org,
      "lots",
      location,
      "countReport"
    );

    const querySnapshot = await getDocs(vinsRef);
    querySnapshot.forEach((doc) => {
      countItems.push(doc.data());
    });
    setCountReportVINs(countItems);

    console.log("Count Report VINs: ", countItems);
    setLoading(false);

    fetchInventoryToken(tekionDealerId);
  }

  async function fetchInventoryToken(tekionDealerId) {
    setLoading(true);
    setLoadingText("Fetching Inventory from DMS...");

    await axios
      .post(
        "https://api.tekioncloud.com/openapi/public/tokens",
        new URLSearchParams({
          app_id: "c179d249-027a-4c19-9d3a-1e6b043bdce5",
          secret_key:
            "AEFE3D9BFA4913230CAB5FAB0C25F9686843E96339D4497E56D63D690CF26766",
        })
      )
      .then((response) => {
        const dataObj = response.data; // Get the response data

        getAllInventoryData(dataObj.data.access_token, "", 1, 0); // Call the function to get all inventory data with the token
      })
      .catch((error) => {
        console.error("Error Fetching Token:", error);
      });
  }

  async function getAllInventoryData(token, nextFetchKey, page, totalCalls) {
    const dealer_id = "applewoodautogroup_2008_0"; // Replace with your actual dealer ID
    const app_id = "c179d249-027a-4c19-9d3a-1e6b043bdce5"; // Replace with your actual app ID

    var api_url = ""; // Initialize the API URL

    if (totalCalls > 0) {
      api_url = `https://api.tekioncloud.com/openapi/v4.0.0/vehicle-inventory?nextPageToken=${nextFetchKey}`; // URL for fetching all inventory data with nextFetchKey
    } else {
      api_url = `https://api.tekioncloud.com/openapi/v4.0.0/vehicle-inventory`; // URL for fetching all inventory data without nextFetchKey
    }

    await axios
      .get(api_url, {
        headers: {
          "Content-Type": "application/json",
          dealer_id: dealer_id,
          app_id: app_id,
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        const dataObj = response.data; // Get the response data
        inventoryData.push(response.data.data); // Push the response data to the inventory array
        var nextFetchKey = dataObj.meta.nextFetchKey; // Get the next fetch key from the response metadata
        console.log("Next Fetch Key: ", nextFetchKey); // Log the next fetch key to the console

        var total = dataObj.meta.total; // Get the total number of inventory from the response metadata
        var count = dataObj.meta.count; // Get the count of inventory from the response metadata

        var total_num_of_calls = Math.ceil(total / count); // Calculate the total number of API calls needed to fetch all inventory data

        console.log("Current Page Inventory: ", response.data);
        console.log("Meta data: ", response.data.meta);
        console.log(
          "Current # of API Calls: ",
          page + " / " + total_num_of_calls
        ); // Log the total number of API calls to the console

        if (page <= total_num_of_calls) {
          page = page + 1; // Increment the page number for the next API call
          console.log("Fetching Next Page..."); // Log the start of fetching the next page
          getAllInventoryData(token, nextFetchKey, page, total_num_of_calls); // Call the function recursively to fetch the next page of inventory data
        } else {
          console.log("All Inventory Data Fetched"); // Log that all inventory data has been fetched

          const uniqueArray = Array.from(
            new Set(inventoryData.map((o) => JSON.stringify(o)))
          ).map((str) => JSON.parse(str));

          const bigData = uniqueArray.flat(1); // Flatten the array of inventory data
          //   console.log("Unique Inventory Data: ", bigData); // Log the unique inventory data to the console

          createInventoryArray(bigData); // Call the function to create an array of vehicles from the inventory data
        }
      })
      .catch((error) => {
        console.error("Error Fetching All Inventory Data:", error);
      });
  }

  function createInventoryArray(data) {
    console.log("Creating Array of Vehicles..."); // Log the start of creating an array of vehicles

    const vehicles = data.filter(
      (item) =>
        !/\s/.test(item.vin) &&
        item.status !== "SOLD" &&
        item.stockSubType !== "" &&
        item.stockSubType !== null &&
        item.stockSubType !== undefined
    ); // Filter the data to get only vehicles

    const flattendedVehicles = vehicles.map((vehicle) => {
      const { vehicleSpecification, pricingDetails } = vehicle; // Destructure the vehicle object to get vehicleSpecification and pricingDetails

      const retailPrice = pricingDetails?.price[0].amount || []; // Get the prices from the pricingDetails, default to an empty array if not present

      const exteriorColor =
        Array.isArray(vehicleSpecification.vehicleColors) &&
        vehicleSpecification.vehicleColors.length > 0
          ? vehicleSpecification.vehicleColors[0].color
          : null;

      const lastSixVin = vehicle.vin.slice(-6); // Get the last six characters of the VIN

      return {
        fullVin: vehicle.vin,
        vin: lastSixVin,
        id: vehicle.id,
        status: vehicle.status,
        stockID: vehicle.stockID,
        stockType: vehicle.stockType,
        stockSubType: vehicle.stockSubType,

        make: vehicleSpecification.make,
        model: vehicleSpecification.model,
        year: vehicleSpecification.year,
        bodyClass: vehicleSpecification.bodyClass,

        cost: retailPrice,
        color: exteriorColor
      };
    });

    console.log("Filtered Vehicles: ", flattendedVehicles); // Log the filtered vehicles to the console
    setInventoryVINs(flattendedVehicles); // Set the inventory data state with the filtered vehicles

    setLoading(false); // Set loading to false after fetching all inventory data
    setShowExceptionDiv(true); // Show the exceptions calculation div
  }

  const calculateExceptions = () => {
    setLoading(true);
    setLoadingText("Calculating Exceptions...");
    console.log("--Exception Arrays--");

    const filtered_overs = countReportVINs.filter(function (vehicle) {
      return !inventoryVINs.some(function (inventoryVin) {
        return vehicle.vin === inventoryVin.vin;
      });
    });

    const filtered_unders = inventoryVINs.filter(function (inventoryVin) {
      return !countReportVINs.some(function (vehicle) {
        return inventoryVin.vin === vehicle.vin;
      });
    });

    filtered_unders.forEach(function (underItem) {
      if (underItem.cost.toString() === "" || underItem.cost === null || underItem.cost === undefined) {
        underItem.cost = "$0";
      } else if (underItem.cost !== undefined){
        underItem.cost = "$" + underItem.cost.toString().slice(0, -2) + "." + underItem.cost.toString().slice(-2);
      } else {
        underItem.cost = "n/a";
      }
    });

    countReportVINs.map((itemCount) => {
      var itemFromInv = inventoryVINs.find(
        (itemInv) => itemInv.vin === itemCount.vin
      );

      if (itemFromInv) {
        itemCount.make = itemFromInv.make;
        itemCount.model = itemFromInv.model;
        itemCount.year = itemFromInv.year;
        itemCount.cost = itemFromInv.cost;
        itemCount.fullVin = itemFromInv.fullVin;
        itemCount.color = itemFromInv.color;
        itemCount.stockID = itemFromInv.stockID;
        console.log("Match Found!: " + itemCount.vin);
      }

      //ADD TO REMOVE - Array.prototype.map() expects a return value from arrow function
      return itemFromInv; //MAY NEED TO CHANGE/DELETE
      //************************************ */
    });
    console.log("unders: ", filtered_unders);
    console.log("overs: ", filtered_overs);

    setUnders(filtered_unders);
    setOvers(filtered_overs);

    setShowExceptionDiv(false);
    setEntryDiv(false);
    setShowResults(true);
    setLoading(false);
  };

  if (loading) {
    return (
      <DoubleBubble
        text={loadingText}
        center={true}
        width={"150px"}
        height={"150px"}
      />
    );
  }

  const handleLocation = (loc) => {
    console.log("Setting Location - " + loc);
    setSubHeader("Location: " + loc);
    setLocation(loc);
  };

  const exportExcel = (exportArray, filename) => {
    import("xlsx").then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(exportArray);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      saveAsExcelFile(excelBuffer, filename);
    });
  };

  function saveAsExcelFile(buffer, fileName) {
    import("file-saver").then((FileSaver) => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      // let date = getTodaysDate();
      const data = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      FileSaver.saveAs(data, fileName + "_" + EXCEL_EXTENSION);
    });
  }

  //HTML
  const SelectLocationDiv = () => (
    <Card id="locationCard" className="exceptCards">
      <Card.Title>Choose a Location</Card.Title>
      <Card.Body class="col-md-3 d-flex justify-content-start align-content-around">
        {lots.map((lot) => (
          <button
            disabled={!lot.countCompleted}
            type="button"
            class="btn btn-primary py-9px btn-exceptions"
            style={{
              backgroundColor: lot.exceptionCompleted ? "#50C878" : "#6B75CC",
            }}
            onClick={() => handleLocation(lot.name)}
          >
            {lot.abbreviation}
          </button>
        ))}
      </Card.Body>
    </Card>
  );

  const ExceptionsCalucateDiv = () => (
    <Card id="calculateCard" className="exceptCards">
      <Card.Title>Calculate Exceptions</Card.Title>
      <Card.Body class="col-md-3 d-flex justify-content-start align-content-around">
        <button
          type="button"
          class="btn btn-primary py-9px btn-exceptions"
          onClick={() => {
            setEntryDiv(false);
            calculateExceptions();
          }}
        >
          Calculate Exceptions
        </button>
      </Card.Body>
    </Card>
  );

    const countHeader = (
      <>
        <div
          class="d-flex justify-content-md-between flex-wrap text-center text-md-left"
          style={{ marginTop: 1.75, marginBottom: 1.75 }}
        >
          <div class="d-flex flex-column">
            <h4 class="d-flex justify-content-start">Count Report</h4>
            <p class="d-flex justify-content-start report-subtext b-subtext mt-1 mb-2">
              Total: {countReportVINs.length}
            </p>
          </div>
        </div>
        <div class="d-flex mt-3 mt-md-0" style={{ gap: 10 }}>
          <button
            type="button"
            className="btn btn-secondary w-full py-9px d-flex align-items-center"
            style={{ maxWidth: 100, gap: 10 }}
            onClick={() => exportExcel(countReportVINs, "Count_Report")}
          >
            <img src={downloadIcon} alt="" />
            <span>EXCEL</span>
          </button>
        </div>
      </>
    );

    const invHeader = (
      <>
        <div
          class="d-flex justify-content-md-between flex-wrap text-center text-md-left"
          style={{ marginTop: 1.75, marginBottom: 1.75 }}
        >
          <div class="d-flex flex-column">
            <h4 class="d-flex justify-content-start">Inventory Report</h4>
            <p class="d-flex justify-content-start report-subtext b-subtext mt-1 mb-2">
              Total: {inventoryVINs.length}
            </p>
          </div>
        </div>
        <div class="d-flex mt-3 mt-md-0" style={{ gap: 10 }}>
          <button
            type="button"
            className="btn btn-secondary w-full py-9px d-flex align-items-center"
            style={{ maxWidth: 100, gap: 10 }}
            onClick={() => exportExcel(inventoryVINs, "Inventory_Report")}
          >
            <img src={downloadIcon} alt="" />
            <span>EXCEL</span>
          </button>
        </div>
      </>
    );

      const undersHeader = (
        <>
          <div
            class="d-flex justify-content-md-between flex-wrap text-center text-md-left"
            style={{ marginTop: 1.75, marginBottom: 1.75 }}
          >
            <div class="d-flex flex-column">
              <h4 class="d-flex justify-content-start">Unders Report</h4>
              <p class="d-flex justify-content-start report-subtext b-subtext mt-1 mb-2">
                Total: {unders.length}
              </p>
            </div>
          </div>
          <div class="d-flex mt-3 mt-md-0" style={{ gap: 10 }}>
            <button
              type="button"
              className="btn btn-secondary w-full py-9px d-flex align-items-center"
              style={{ maxWidth: 100, gap: 10 }}
              onClick={() => exportExcel(unders, "Unders_Report")}
            >
              <img src={downloadIcon} alt="" />
              <span>EXCEL</span>
            </button>
          </div>
        </>
      );

        const oversHeader = (
          <>
            <div
              class="d-flex justify-content-md-between flex-wrap text-center text-md-left"
              style={{ marginTop: 1.75, marginBottom: 1.75 }}
            >
              <div class="d-flex flex-column">
                <h4 class="d-flex justify-content-start">Overs Report</h4>
                <p class="d-flex justify-content-start report-subtext b-subtext mt-1 mb-2">
                  Total: {overs.length}
                </p>
              </div>
            </div>
            <div class="d-flex mt-3 mt-md-0" style={{ gap: 10 }}>
              <button
                type="button"
                className="btn btn-secondary w-full py-9px d-flex align-items-center"
                style={{ maxWidth: 100, gap: 10 }}
                onClick={() => exportExcel(overs, "Overs_Report")}
              >
                <img src={downloadIcon} alt="" />
                <span>EXCEL</span>
              </button>
            </div>
          </>
        );

  const exceptionsHeader = (
    <>
      <div class="d-flex flex-column marginCover">
        <h2 class="report-title text-left mb-1">Inventory Exceptions</h2>
        <p class="location-subheader">{subHeader}</p>
      </div>
    </>
  );

  const ResultsDiv = () => (
    <div id="resultTables">
      <TabView
        activeIndex={activeIndex}
        onTabChange={(e) => setActiveIndex(e.index)}
      >
        <TabPanel header="Overs">
          <DataTable
            id="oversTable"
            className="exceptTables"
            value={overs}
            paginator
            stripedRows
            rows={25}
            header={oversHeader}
            emptyMessage="No Overs Founds"
          >
            {oversColumns}
          </DataTable>
        </TabPanel>

        <TabPanel header="Unders">
          <DataTable
            id="undersTable"
            className="exceptTables"
            value={unders}
            paginator
            stripedRows
            rows={25}
            header={undersHeader}
            emptyMessage="No unders Founds"
          >
            {inventoryColumns}
          </DataTable>
        </TabPanel>

        <TabPanel header="Count Report">
          <DataTable
            id="countExceptionTable"
            className="exceptTables"
            value={countReportVINs}
            paginator
            stripedRows
            rows={25}
            header={countHeader}
          >
            {countColumns}
          </DataTable>
        </TabPanel>

        <TabPanel header="Inventory Report">
          <DataTable
            id="invExceptionTable"
            className="exceptTables"
            value={inventoryVINs}
            paginator
            stripedRows
            rows={25}
            header={invHeader}
          >
            {inventoryColumns}
          </DataTable>
        </TabPanel>
      </TabView>
    </div>
  );

  return (
    <Container>
      {exceptionsHeader}

      {showEntryDiv ? <SelectLocationDiv /> : null}

      {showExceptionDiv ? <ExceptionsCalucateDiv /> : null}

      {showResults ? <ResultsDiv /> : null}
    </Container>
  );
}

export default InventoryExceptions;
